import { render, staticRenderFns } from "./SupervisionIndexPage.vue?vue&type=template&id=01fd6d3d"
import script from "./SupervisionIndexPage.vue?vue&type=script&lang=js"
export * from "./SupervisionIndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports